class BitsCollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.bindEvents();
    this.syncWithFilterDrawer();
  }

  bindEvents() {
    this.addEventListener('click', this.handleFilterClick.bind(this));
    
    // Listen for filter changes from the facets system
    document.addEventListener('input', this.handleFacetInput.bind(this));
    
    // Listen for URL changes (back/forward buttons)
    window.addEventListener('popstate', this.handlePopState.bind(this));
  }

  handleFilterClick(event) {
    const pill = event.target.closest('.bits-filter__pill');
    if (!pill) return;

    const isActive = pill.classList.contains('bits-filter__pill--active');
    const filterValue = pill.dataset.filterValue;
    const filterParam = pill.dataset.filterParam;
    
    if (!filterValue || !filterParam) return;

    // Prevent default button behavior
    event.preventDefault();
    
    if (isActive) {
      // Remove filter - trigger the remove functionality
      this.removeFilter(filterParam, filterValue);
    } else {
      // Add filter - trigger the add functionality
      this.addFilter(filterParam, filterValue);
    }
  }

  addFilter(paramName, value) {
    // Find the corresponding checkbox in the filter drawer
    const checkbox = document.querySelector(`input[name="${paramName}"][value="${value}"]`);
    
    if (checkbox) {
      // Trigger the checkbox click to add the filter
      checkbox.checked = true;
      // Trigger input event to activate facets system
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      // Fallback: construct the URL and navigate
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.set(paramName, value);
      window.location.href = currentUrl.toString();
    }
  }

  removeFilter(paramName, value) {
    // Find the corresponding checkbox in the filter drawer
    const checkbox = document.querySelector(`input[name="${paramName}"][value="${value}"]`);
    
    if (checkbox) {
      // Trigger the checkbox click to remove the filter
      checkbox.checked = false;
      // Trigger input event to activate facets system
      checkbox.dispatchEvent(new Event('input', { bubbles: true }));
    } else {
      // Fallback: construct the URL and navigate
      const currentUrl = new URL(window.location);
      currentUrl.searchParams.delete(paramName);
      window.location.href = currentUrl.toString();
    }
  }

  handleFacetInput(event) {
    // Only handle events from filter checkboxes
    if (event.target.type === 'checkbox' && event.target.name.includes('filter.')) {
      // Debounce the sync to avoid multiple updates
      clearTimeout(this.syncTimeout);
      this.syncTimeout = setTimeout(() => {
        this.syncWithFilterDrawer();
      }, 100);
    }
  }

  handlePopState() {
    // Sync when browser back/forward is used
    setTimeout(() => {
      this.syncWithFilterDrawer();
    }, 100);
  }

  syncWithFilterDrawer() {
    const pills = this.querySelectorAll('.bits-filter__pill');
    
    pills.forEach(pill => {
      const paramName = pill.dataset.filterParam;
      const value = pill.dataset.filterValue;
      
      if (paramName && value) {
        // Check if this filter is active in the drawer
        const checkbox = document.querySelector(`input[name="${paramName}"][value="${value}"]`);
        const isActive = checkbox && checkbox.checked;
        
        this.updatePillState(pill, isActive);
      }
    });
  }

  updatePillState(pill, isActive) {
    if (isActive) {
      pill.classList.add('bits-filter__pill--active');
      pill.setAttribute('aria-pressed', 'true');
    } else {
      pill.classList.remove('bits-filter__pill--active');
      pill.setAttribute('aria-pressed', 'false');
    }
  }

  clearAllPills() {
    const pills = this.querySelectorAll('.bits-filter__pill');
    pills.forEach(pill => {
      this.updatePillState(pill, false);
    });
  }

  // Method to manually sync (can be called from other components)
  sync() {
    this.syncWithFilterDrawer();
  }
}

customElements.define('bits-collection-filters', BitsCollectionFilters); 